<template>
  <transition name="ticket-modal-fade">
    <div class="ticket-modal-backdrop" role="presentation" @mousedown.self="requestClose">
      <section ref="dialog" class="ticket-modal-panel" role="dialog" tabindex="-1" aria-modal="true" :aria-label="$t('ticketDetail.title')">
        <div class="ticket-modal-scroll"><slot /></div>
      </section>
    </div>
  </transition>
</template>

<script>
import { registerDialog } from '@/utils/dialogAccessibility';
export default {
  name: 'TicketDetailModal',
  mounted() {
    this.activateDialog()
  },
  beforeDestroy() {
    this.releaseDialog()
  },
  activated() { this.activateDialog() },
  deactivated() { this.releaseDialog() },
  methods: {
    activateDialog() {
      if (this._dialog) return;
      this._closeRequested = false;
      this._dialog = registerDialog(this.$refs.dialog, {
        ticket: true,
        layers: () => [this.$el],
        initialFocus: () => this.$refs.dialog.querySelector('.sa-detail-back, button'),
        close: this.requestClose,
      });
    },
    releaseDialog() {
      if (this._dialog) this._dialog.release();
      this._dialog = null;
    },
    requestClose() {
      if (this._closeRequested || !this._dialog?.isTop()) return;
      this._closeRequested = true;
      this.$emit('close');
    },
  },
}
</script>

<style scoped>
.ticket-modal-backdrop{position:fixed;inset:0;z-index:100000;display:flex;align-items:center;justify-content:center;padding:28px;background:rgba(24,18,18,.62);backdrop-filter:blur(2px)}.ticket-modal-panel{width:min(94vw,1680px);height:min(92vh,1100px);overflow:hidden;background:#eff6ff;border:1px solid rgba(37, 99, 235,.2);border-radius:18px;box-shadow:0 30px 90px rgba(0,0,0,.35)}.ticket-modal-scroll{width:100%;height:100%;overflow-x:hidden;overflow-y:auto;overscroll-behavior:contain}::v-deep .detail-card{width:100%;min-height:100%;margin:0!important;border:0!important;border-radius:0!important;box-shadow:none!important}.ticket-modal-fade-enter-active,.ticket-modal-fade-leave-active{transition:opacity .18s ease}.ticket-modal-fade-enter,.ticket-modal-fade-leave-to{opacity:0}@media(max-width:768px){.ticket-modal-backdrop{padding:0;align-items:stretch}.ticket-modal-panel{width:100vw;height:100dvh;max-height:none;border:0;border-radius:0}.ticket-modal-scroll{padding-bottom:env(safe-area-inset-bottom)}}
</style>

<style>
@media (max-width: 768px) {
  body.ticket-detail-modal-open .c-header,
  body.ticket-detail-modal-open .role-bottom-nav,
  body.ticket-detail-modal-open .u-bottom-nav {
    visibility: hidden !important;
    pointer-events: none !important;
  }
}
</style>
